import axios from 'axios';

const API_URL = import.meta.env.VITE_BACKEND_BASE_URL;

const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 10000, // 10 segundos de timeout
  withCredentials: true, // Permite el envío de cookies entre dominios
});

// Interceptor de solicitud
axiosInstance.interceptors.request.use(
  (config) => {
    // Puedes agregar lógica para inyectar tokens u otros headers
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor de respuesta
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Manejo de errores global
    return Promise.reject(error.response?.data || { message: 'Error desconocido' });
  }
);

export default axiosInstance;
